import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
    useEffect(() => {
        document.body.classList.add("public-auth-scroll");

        return () => {
            document.body.classList.remove("public-auth-scroll");
        };
    }, []);

    return (
        <div className="public-auth-layout">
            <h1 className="visually-hidden">{"Application"}</h1>
            <header>
                <Header />
            </header>
            <main className="public-auth-main">
                <Outlet />
            </main>
            <footer>
                <Footer />
            </footer>
        </div>
    );
};

export default Layout;
